import * as React from 'react'
import { AlertContainer, AlertContent } from './AlertStyles'

const AlertModal = props => (
  <AlertContainer>
    <AlertContent>
      <div className="topbar" />
      <div className="content">{props.children}</div>
    </AlertContent>
  </AlertContainer>
)

export default AlertModal



// WEBPACK FOOTER //
// ./src/Components/Shared/Alerts/AlertModal.tsx